import React, { Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import handleRenderOption from "./handleRenderOption";
import useCatalogos from "../../../hooks/useCatalogos";
const AutoInput = (props) => {
  const {name="", label="", setTarget=()=>{}, error=false, helperText="", disabled=false} = props;
  const catalogoIATA = useCatalogos("IATA")
  const getOptionHangle = (event, valor) =>{
    if(valor){
      setTarget(valor)
    } else {
      setTarget({IdCodigo: 0})
    }
  }
  return (
    <Fragment>
      <Autocomplete
        id={`id-auto-${name}`}
        options={catalogoIATA.sort((a, b) => a.CodigoIATA > b.CodigoIATA)}
        getOptionLabel={(option) => `${option.CodigoIATA} ${option.Descripcion}`}
        style={{ width: "97%", margin: "5px", paddingBottom: "0", fontWeight: "500" }}
        onChange={getOptionHangle}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            style={{ width: "100%" }}
            name={name}
            error={error}
            helperText={helperText}
            disabled={disabled}
          />
        )}
        renderOption={handleRenderOption}
      />
    </Fragment>
  );
};
export default AutoInput;
